<ng-container *ngIf="dataSource.paginatedOnce$ | async">
    <header>
        <h1>{{ (dataSource.totalCount$ | async)}} <span trans>Playlists</span></h1>
        <div class="right-column">
            <div class="input-container">
                <input type="text" id="playlist-search" [formControl]="dataSource.searchControl" placeholder="Filters playlists..." trans-placeholder>
            </div>
        </div>
    </header>

    <ad-host slot="ads.general_top" class="margin-bottom"></ad-host>

    <media-grid>
        <playlist-item *ngFor="let playlist of playlists$ | async; trackBy: trackByFn" [playlist]="playlist" [contextMenu]="{item: playlist, type: 'playlist'}"></playlist-item>
    </media-grid>
</ng-container>

<loading-indicator [isVisible]="dataSource.loading$ | async" class="inline"></loading-indicator>

<div class="no-results-message" *ngIf="dataSource.noResults$ | async">
    <mat-icon class="icon" svgIcon="album"></mat-icon>
    <div class="text">
        <div class="main" trans>Nothing to display.</div>
        <div class="secondary" trans>You have not added any playlists to your library yet.</div>
    </div>
</div>